import script from "./PersonalOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalOrder.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalOrder.vue?vue&type=style&index=0&id=8f4b50ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f4b50ac"]])

export default __exports__